import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IMetricDescriptionParams {
  id: string;
  description: string;
}

export class SetMetricDescriptionRequest extends Request<IMetricDescriptionParams, IResult> {
  constructor(params: IMetricDescriptionParams) {
    super('setMetricDescription', params);
  }
}
